import axios from "axios";

// API Configuration
// Get base URL from environment variable, meta tag, or window location
const getBaseUrl = () => {
  // First check environment variable
  if (import.meta.env.VITE_API_URL) {
    return import.meta.env.VITE_API_URL;
  }

  // Use the local Laravel server when the frontend runs on localhost
  if (typeof window !== "undefined") {
    const hostname = window.location.hostname;
    if (hostname === "localhost" || hostname === "127.0.0.1") {
      return "https://skillsiksha.in";
    }
  }

  // Then check meta tag (set from index.html)
  if (typeof document !== "undefined") {
    const metaTag = document.querySelector('meta[name="base-url"]');
    if (metaTag && metaTag.getAttribute("content")) {
      return metaTag.getAttribute("content");
    }
  }

  // Finally use window location origin or fallback
  if (typeof window !== "undefined" && window.location) {
    return window.location.origin;
  }

  // Default fallback
  return "https://skillsiksha.in";
};

const API_BASE_URL = getBaseUrl();

// Create axios instance
const api = axios.create({
  baseURL: `${API_BASE_URL}/api`,
  headers: {
    "Content-Type": "application/json",
    Accept: "application/json",
  },
});

// Add request interceptor for debugging
api.interceptors.request.use(
  (config) => {
    console.log("API Request:", config.method?.toUpperCase(), config.url);
    return config;
  },
  (error) => {
    console.error("API Request Error:", error);
    return Promise.reject(error);
  }
);

// Add response interceptor for debugging
api.interceptors.response.use(
  (response) => {
    console.log("API Response:", response.status, response.config.url);
    return response;
  },
  (error) => {
    console.error(
      "API Response Error:",
      error.response?.status,
      error.config?.url
    );
    console.error("Error details:", error.response?.data);
    return Promise.reject(error);
  }
);

export const getApiUrl = (endpoint) => {
  // Remove leading slash if present
  let cleanEndpoint = endpoint.startsWith("/") ? endpoint.slice(1) : endpoint;

  // Don't add 'api/' if it's already there
  if (!cleanEndpoint.startsWith("api/")) {
    cleanEndpoint = `api/${cleanEndpoint}`;
  }

  // Remove trailing slash from base URL
  const baseUrl = API_BASE_URL.endsWith("/")
    ? API_BASE_URL.slice(0, -1)
    : API_BASE_URL;

  // Construct final URL
  const finalUrl = `${baseUrl}/${cleanEndpoint}`;
  return finalUrl;
};

export { API_BASE_URL };
export default api;
